module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7yxt8l/tc-custom/9781488011689.jpg?1705237075086",
      "alt": "This image is the cover for the book Unbridled Billionaire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unbridled Billionaire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Cinderella moment with an untamable billionaire might just turn a woman’s reality into a fairy tale come true.")]), _c('br'), _c('br'), _vm._v("Presley Macarthur was always a plain Jane, a fact her stepmother pointed out at every turn. But Presley’s passion is horses, and when a bad business deal leaves her at the mercy of newly wealthy stable owner Kane Harrington, Presley finds herself on the brink of a sensual transformation she never saw coming."), _c('br'), _c('br'), _vm._v("Kane has a use for Presley—to make him legitimate in the exclusive world of high-dollar horse breeding. But there’s nothing useful about his growing feelings for her. After losing it all before, is he willing to take the ultimate risk again, and make this woman’s passionate awakening complete?"), _c('br'), _c('br'), _c('b', [_vm._v("“Will appeal to readers who like horse themed romances and seeing heroines become the best version of themselves.” —"), _c('i', [_vm._v("Harlequin Junkie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dani Wade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Dani Wade astonished her local librarians as a teenager when she carried home 10 books every week—and actually read them all. Now she writes her own characters who clamor for attention in the midst of the chaos that is her life. Residing in the southern U.S. with a husband, two kids, two dogs, and one grumpy cat, she stays busy until she can closet herself away with her characters once more.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0